import { useCallback } from "react";
import { StorageFile } from "api/model/StorageFile";
import { Collections } from "api/model/Collections";
import { useFirebase, useFirestore } from "react-redux-firebase";

interface DeleteFileHookOptions {
    onDelete?: () => void;
}

export const useDeleteFile = () => {
    const firebase = useFirebase();
    const firestore = useFirestore();

    return useCallback(
        (file: StorageFile, options?: DeleteFileHookOptions) => {
            const { onDelete } = options || {};
            const storageRef = firebase.storage().ref(file.fullPath);
            return storageRef
                .delete()
                .then(() =>
                    firestore
                        .collection(Collections.STORAGE_FILES)
                        .doc(file.storageFileId)
                        .delete()
                )
                .then(() => {
                    if (onDelete) {
                        onDelete();
                    }
                });
        },
        [firebase, firestore]
    );
};
